import Box from '~/common/components/Box';
import Tooltip from '~/common/components/Tooltip';

export default function Overflow({
  children,
  label,
}: Readonly<
  | { children: string; label?: never }
  | {
      label: string;
      children: React.ReactNode;
    }
>) {
  return (
    <Tooltip label={label ?? (children as string)}>
      <Box
        sx={{
          width: '100%',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {children}
      </Box>
    </Tooltip>
  );
}
